import { Component } from '@angular/core';
import { AuthService } from '../../providers/auth-service';
import { AlertController, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { CajaProvider } from '../../providers/caja/caja';
import { UtilsProvider } from '../../providers/utils/utils';
import { valueDisplay } from '../../models/valueDisplay.model';
import * as fromClienteSelect from '../../pages/cliente-select/state/cliente-select/cliente-select-accions'
import { Store } from '@ngrx/store';
import { State } from '../../store/app.reducer'
import { ClienteSelectPage } from '../../pages/cliente-select/cliente-select';
import { AppState } from '../../app/app.reducer';
@Component({
  selector: 'proveedora-actualizar-producto',
  templateUrl: 'proveedora-actualizar-producto.html',
  providers: [ AuthService ]
})
export class ProveedoraActualizarProductoComponent {
  clienteId = []
  clienteGenerico
  valoresCliente: string = 'Buscar Cliente';
  listaClientes = [];
  companiasId
  factura:number = 0
  constructor(public auth: AuthService,public navCtrl: NavController,
    public viewControllers:ViewController,private storage: Storage,
    public servicio:CajaProvider,public navParams: NavParams,
    public utils:UtilsProvider,
    private store:Store<State>,
    public modalControllers: ModalController,
    private storePedidosSalon: Store<AppState>,
    public alertControllers: AlertController,
  ) {
    if(this.navParams.get('item')){
      let item = this.navParams.get('item')
      if(!item) {
        this.utils.mensajeMuestro('Advertencia','Usted no selecciono una factura valida','warning')
        this.viewControllers.dismiss([]);
        return
      }
      this.visualizarDetalleVenta(item);
    }
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }
  dismiss() {
    this.cerrarModal()
  }
  cerrarModal() {
    this.viewControllers.dismiss([]);
  }
  visualizarDetalleVenta(reciboCaja: any){
    let textoHtmlReciboCaja = reciboCaja.factura

    this.storage.get('companiasId').then((val) => {
      let factura:number
      factura = Number(textoHtmlReciboCaja)
      this.companiasId = val
      this.factura = factura
      this.buscarClientes(val);
      this.armarInformeVenta(this.factura,val);
    })
  }

  armarInformeVenta(factura:any,companiasId: any) {
    this.servicio.buscarVentasDiarias(factura,companiasId)
    .subscribe((elReciboDeCaja)=>{
      let recibo =  `<div align="left" style='font-family: monospace;'> `
      elReciboDeCaja = elReciboDeCaja.length> 0 ? elReciboDeCaja : JSON.parse(elReciboDeCaja['_body']).data[0]

      for (let index:any = 0; index < elReciboDeCaja.length; index++) {
        recibo += elReciboDeCaja[index]['reciboCaja'].replace(/\ /g,'&nbsp;') + '<br/>'
      }
      recibo += '</div>'

      document.getElementById('contenidoRecibo').innerHTML = recibo;
    },
    error=>{
      console.log(error)
    })
  }
  buscarClienteSelect() {
    let modal = this.modalControllers.create(ClienteSelectPage, { data: this.listaClientes }
      )
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {
        this.clienteId = []
        this.clienteId.push({value:data.value, display:data.display})
        let cliente: valueDisplay[] = [{
          value:data.value,
          display:data.display
        }]
        const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
        this.store.dispatch(actionClienteCaja);
        this.valoresCliente = 'Buscar Cliente : ' + data.display;
      }
    })
  }
  limpiarNombreCliente() {
    this.valoresCliente = 'Buscar Cliente'
  }
  buscarClientes(companiasId) {
    this.servicio.buscarClientesPorCompaniaAll(companiasId)
    .subscribe((data: any)=>{
      let clientes: any = data;
      this.listaClientes = clientes;
    })
  }
  async actualizar() {
    let clienteCaja = await this.buscarClienteStore();
    let idcliente = 0;

    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
      // envia el cliente que este seleccionado
      idcliente  = clienteCaja['valuedisplay'][0].value
  } else if(this.clienteGenerico && this.clienteGenerico[0] && this.clienteGenerico[0]['clientesId']) {
      // si tiene un cliente generico seleccionado
      idcliente = this.clienteGenerico[0]['clientesId']
  } else {
          this.utils.mostrarMensaje("advertencia",`Para actualizar la factura debe asignar un cliente`)
           return
  }
  if( this.companiasId == undefined || this.factura == 0) {
    this.utils.mostrarMensaje("advertencia",`Intente hacer este proceso luego`)
    return
  } else {
    this.servicio.actualizarClienteFactura(this.companiasId, idcliente, this.factura)
    .subscribe((data)=>{
      var valorDevolvio = JSON.parse(data['_body'])
      let consecutivo = valorDevolvio.data[0][0].consecutivo
      let companiasId = valorDevolvio.data[0][0].companiasId
      let factura = Number(consecutivo)
      this.armarInformeVenta(factura,companiasId);
      this.mostrarMensajeExito("Se actualizo con exito el cliente en la factura N° " + consecutivo);
    }, (error)=>{

      console.log(error)
    })
  }
  }

  mostrarMensajeExito(mensaje) {
    let alert = this.alertControllers.create({
      title: 'Registro actualizado con éxito',
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();

    setTimeout(() => {
      alert.dismiss();
    }, 1500); // 1500 milisegundos = 1.5 segundos
  }

  async buscarClienteStore() {
    return new Promise((resolve, reject) => {
       this.storePedidosSalon.select('clienteSelect').subscribe((clientecaja) => {
         return resolve(clientecaja)
       })
     });
   }
}



// WEBPACK FOOTER //
// ./src/components/proveedora-actualizar-producto/proveedora-actualizar-producto.ts